enum QUERY_KEYS {
  INSTALLATIONS = "INSTALLATIONS",
  COMPONENTS = "COMPONENTS",
}

export default QUERY_KEYS;
